const tableInitState = {
  loading: false,
  error: {},
  tables: []
};

export default function targetTableReducer(state = tableInitState, action) {
  switch (action.type) {
    case 'FETCH_TARGET_TABLES_START':
      return { ...state, loading: true };

    case 'FETCH_TARGET_TABLES_SUCCESS': {
      const { tables } = action.payload;
      return { ...state, loading: false, error: {}, tables };
    }

    case 'FETCH_TARGET_TABLES_FAILED': {
      return { ...state, loading: false, error: action.payload.error };
    }

    default:
      return state;
  }
}
